import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { fadeUp, stagger } from "@/lib/motion";
import { ArrowUpRight, BookOpen, ArrowRight } from "lucide-react";
import { articles } from "@/lib/articles";

export default function Insights() {
  // Show only first 3 on home
  const featured = articles.slice(0, 3);

  return (
    <section
      id="insights"
      data-testid="insights-section"
      className="py-24 sm:py-32 bg-card/40"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14 lg:mb-20 items-end">
          <motion.div {...fadeUp} className="lg:col-span-7">
            <p className="text-[11px] tracking-[0.25em] uppercase font-body font-medium text-primary mb-5">
              Άρθρα &amp; Γνώση
            </p>
            <h2
              data-testid="insights-heading"
              className="font-heading font-medium tracking-tight text-foreground text-4xl sm:text-5xl lg:text-[60px] leading-[1.05]"
            >
              Σύντομες <span className="italic font-light">αναγνώσεις.</span>
            </h2>
          </motion.div>
          <motion.div
            {...fadeUp}
            transition={{ ...fadeUp.transition, delay: 0.1 }}
            className="lg:col-span-5"
          >
            <p className="text-lg font-body font-light text-foreground/70 leading-relaxed">
              Επιστημονικά τεκμηριωμένο περιεχόμενο για να κατανοήσεις καλύτερα
              τον εαυτό σου — χωρίς ορολογίες και ψεύτικες υποσχέσεις.
            </p>
            <Link
              to="/arthra"
              data-testid="all-articles-link"
              className="mt-5 inline-flex items-center gap-2 text-sm font-body text-foreground hover:text-primary transition-colors"
            >
              Όλα τα άρθρα
              <ArrowRight size={14} strokeWidth={1.5} />
            </Link>
          </motion.div>
        </div>

        <motion.div
          {...stagger(0.08)}
          className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6"
        >
          {featured.map((a, i) => (
            <motion.div
              key={a.slug}
              variants={{
                initial: { opacity: 0, y: 30 },
                whileInView: {
                  opacity: 1,
                  y: 0,
                  transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
                },
              }}
            >
              <Link
                to={`/arthra/${a.slug}`}
                data-testid={`article-card-${i}`}
                className="group h-full block bg-background border border-border/60 rounded-3xl p-7 sm:p-8 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_20px_60px_rgb(42,54,46,0.06)]"
              >
                <div className="flex items-center justify-between mb-5">
                  <span className="inline-flex items-center gap-2 text-[10px] tracking-[0.22em] uppercase font-body font-medium text-primary">
                    <BookOpen size={12} strokeWidth={1.5} /> {a.tag}
                  </span>
                  <span className="text-xs font-body text-muted-foreground">
                    {a.readTime}
                  </span>
                </div>
                <h3 className="font-heading font-medium text-foreground tracking-tight text-2xl sm:text-[26px] leading-[1.15]">
                  {a.title}
                </h3>
                <p className="mt-4 font-body font-light text-foreground/70 leading-relaxed text-base">
                  {a.excerpt}
                </p>
                <span className="mt-5 inline-flex items-center gap-2 text-sm font-body text-foreground/80">
                  Διάβασέ το
                  <ArrowUpRight
                    size={16}
                    strokeWidth={1.5}
                    className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  />
                </span>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
